import { styled } from 'canoe';
import React from 'react';

const Line = styled.div`
  position: absolute;
  z-index: 0;
`;

export const StyledGrid = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  pointer-events: none;

  opacity: 1;
  transition: opacity 0.1s linear;
`;

const activeBorder = '1px dashed #4392F1';

const greyBorder = '1px dashed #D4D8E4';

interface Props {
  isSelected?: boolean;
  shouldHideLine: boolean;
}

export const DocumentGrid = ({ isSelected, shouldHideLine }: Props) => {
  return (
    <StyledGrid>
      {/* Top line */}
      {!shouldHideLine && (
        <Line
          id="top-edge"
          css={{
            top: -1,
            width: '100%',
            borderBottom: isSelected ? activeBorder : greyBorder,
          }}
        />
      )}
    </StyledGrid>
  );
};
